<template>
  <div id="help-text" class="heavy" :class="horizontal ? 'grid-x' : 'grid-y'">
    <span :class="horizontal ? 'margin-right-xxxs' : 'margin-bottom-xxs'" v-text="NEED_HELP.needHelpLabel"></span>
    <button v-if="isMarketplaceOrder" id="contact-seller" class="link-heavy" @click="contactSeller" v-text="NEED_HELP.contactSellerLabel"></button>
    <div v-else>
      <span v-if="showChat" id="rnowChatLinkContainer_type10" :class="[chatClass, liveChatClass]"></span>
      <span id="faqText" aria-hidden="true" v-text="NEED_HELP.visitLabel"></span>
      <NuxtLink id="faq-link" class="link-heavy" :to="faqUrl" external target="_blank" :aria-label="NEED_HELP.visitLabel + NEED_HELP.faqLabel">
        {{ NEED_HELP.faqLabel }}
      </NuxtLink>
      <template v-if="showPhoneNumber">
        {{ NEED_HELP.orCallLabel }}
        <NuxtLink id="phone-num" class="link-heavy" :to="helpLineUrl" external>{{ helpLine }}</NuxtLink>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { brand, CUSTOMER_SERVICE, CUSTOMER_SERVICE_BT, NEED_HELP } from 'config';

const props = defineProps({
  isMarketplaceOrder: {
    type: Boolean,
    required: false,
    default: false,
  },
  horizontal: {
    type: Boolean,
    required: false,
    default: false,
  },
  showPhoneNumber: {
    type: Boolean,
    required: false,
    default: false,
  },
  shipmentType: {
    type: String,
    default: 'ST',
  },
  chatClass: {
    type: String,
    default: '',
    required: false,
  },
  showChat: {
    type: Boolean,
    default: false,
    required: false,
  },
});
const emit = defineEmits(['contact-seller']);

const faqUrl = computed(() => {
  if (props.shipmentType === 'BT' || props.chatClass === 'furniture-lookup') return NEED_HELP.furnitureFaqUrl;
  return NEED_HELP.faqUrl;
});

const helpLine = computed(() => {
  if (props.shipmentType === 'BT') return CUSTOMER_SERVICE_BT;
  return CUSTOMER_SERVICE;
});

const helpLineUrl = computed(() => (brand === 'bcom' ? NEED_HELP.helpLineUrl : `tel:+${helpLine.value}`));

const liveChatClass = computed(() => {
  if (props.shipmentType === 'BT') return 'big-ticket-live-chat'; // Do not remove: Class name used for chat implementation.
  return '';
});

const contactSeller = () => {
  emit('contact-seller');
};
</script>

<style lang="scss">
.margin-right-xxxs {
  margin-right: rem-calc(4px);
}
</style>
